"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _dmet = require("../../extensions/dmet");
var _CloudVariable = _interopRequireDefault(require("../../extensions/CloudVariable"));
var _throttle2 = _interopRequireDefault(require("lodash/throttle"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var getColumns = function getColumns(table, indexes) {
  var wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (x) {
    return x;
  };
  return indexes.map(function (index) {
    return table.map(function (field) {
      return wrapper(field[index]);
    });
  });
};
function corr(d1, d2) {
  var min = Math.min,
    pow = Math.pow,
    sqrt = Math.sqrt;
  var add = function add(a, b) {
    return Number(a) + Number(b);
  };
  var n = min(d1.length, d2.length);
  if (n === 0) {
    return 0;
  }
  var _ref = [d1.slice(0, n), d2.slice(0, n)];
  d1 = _ref[0];
  d2 = _ref[1];
  var _map = [d1, d2].map(function (l) {
      return l.reduce(add);
    }),
    _map2 = (0, _slicedToArray2["default"])(_map, 2),
    sum1 = _map2[0],
    sum2 = _map2[1];
  var _map3 = [d1, d2].map(function (l) {
      return l.reduce(function (a, b) {
        return a + pow(b, 2);
      }, 0);
    }),
    _map4 = (0, _slicedToArray2["default"])(_map3, 2),
    pow1 = _map4[0],
    pow2 = _map4[1];
  var mulSum = d1.map(function (n, i) {
    return n * d2[i];
  }).reduce(add);
  var dense = sqrt((pow1 - pow(sum1, 2) / n) * (pow2 - pow(sum2, 2) / n));
  if (dense === 0) {
    return 0;
  }
  return ((mulSum - sum1 * sum2 / n) / dense).toFixed(2);
}
var _id = /*#__PURE__*/new WeakMap();
var _name = /*#__PURE__*/new WeakMap();
var _data = /*#__PURE__*/new WeakMap();
var _object = /*#__PURE__*/new WeakMap();
var _isCloud = /*#__PURE__*/new WeakMap();
var _cloudDate = /*#__PURE__*/new WeakMap();
var _chart = /*#__PURE__*/new WeakMap();
var _cloudVariable = /*#__PURE__*/new WeakMap();
var _source = /*#__PURE__*/new WeakMap();
var _copiedChart = /*#__PURE__*/new WeakMap();
var DataTableSource = /*#__PURE__*/function () {
  function DataTableSource() {
    var _this = this;
    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, DataTableSource);
    _classPrivateFieldInitSpec(this, _id, void 0);
    _classPrivateFieldInitSpec(this, _name, void 0);
    _classPrivateFieldInitSpec(this, _data, void 0);
    _classPrivateFieldInitSpec(this, _object, void 0);
    _classPrivateFieldInitSpec(this, _isCloud, false);
    _classPrivateFieldInitSpec(this, _cloudDate, null);
    _classPrivateFieldInitSpec(this, _chart, []);
    _classPrivateFieldInitSpec(this, _cloudVariable, _CloudVariable["default"].getInstance());
    _classPrivateFieldInitSpec(this, _source, void 0);
    _classPrivateFieldInitSpec(this, _copiedChart, void 0);
    (0, _defineProperty2["default"])(this, "summary", void 0);
    (0, _defineProperty2["default"])(this, "provider", void 0);
    (0, _defineProperty2["default"])(this, "description", void 0);
    (0, _defineProperty2["default"])(this, "fieldInfos", void 0);
    (0, _defineProperty2["default"])(this, "modals", []);
    (0, _defineProperty2["default"])(this, "updated", new Date());
    (0, _defineProperty2["default"])(this, "tab", 'summary');
    var name = source.name,
      _source$id = source.id,
      id = _source$id === void 0 ? Entry.generateHash() : _source$id,
      _source$object = source.object,
      object = _source$object === void 0 ? null : _source$object,
      chart = source.chart,
      data = source.data,
      _source$tab = source.tab,
      tab = _source$tab === void 0 ? 'summary' : _source$tab,
      _source$fields = source.fields,
      fields = _source$fields === void 0 ? [] : _source$fields,
      summary = source.summary,
      updatedAt = source.updatedAt,
      provider = source.provider,
      description = source.description,
      fieldInfos = source.fieldInfos;
    _classPrivateFieldSet(_name, this, name);
    _classPrivateFieldSet(_id, this, id);
    _classPrivateFieldSet(_object, this, object);
    _classPrivateFieldSet(_source, this, source);
    _classPrivateFieldSet(_data, this, new _dmet.dmetTable(source));
    _classPrivateFieldSet(_chart, this, chart || []);
    this.summary = summary;
    this.provider = provider;
    this.description = description;
    this.fieldInfos = fieldInfos;
    this.tab = tab;
    this.updated = updatedAt ? new Date(updatedAt) : new Date();
    // 정지시 data 초기화.
    Entry.addEventListener('stop', function () {
      _this.modals = [];
      _classPrivateFieldGet(_data, _this).from(_objectSpread(_objectSpread({}, source), {}, {
        data: _classPrivateFieldGet(_data, _this).origin,
        fields: _classPrivateFieldGet(_data, _this).originFields
      }));
      _classPrivateFieldSet(_copiedChart, _this, undefined);
    });
    var apply = function apply() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (_this.modals.length > 0 && (force || _this.modals.some(function (modal) {
        return modal.isShow;
      }))) {
        _this.modals.forEach(function (modal) {
          return modal.setData({
            source: {
              chart: _this.copiedChart,
              fields: _this.fields,
              origin: _this.rows,
              tab: _this.tab,
              summary: _this.summary
            }
          });
        });
      }
    };
    this.forceApply = function () {
      return apply(true);
    };
    this.applyChart = (0, _throttle2["default"])(apply, 1000);
  }
  return (0, _createClass2["default"])(DataTableSource, [{
    key: "rows",
    get: function get() {
      return this.array.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      });
    }
  }, {
    key: "id",
    get: function get() {
      return _classPrivateFieldGet(_id, this);
    }
  }, {
    key: "name",
    get: function get() {
      return _classPrivateFieldGet(_name, this);
    },
    set: function set(name) {
      _classPrivateFieldSet(_name, this, name);
    }
  }, {
    key: "fields",
    get: function get() {
      return _classPrivateFieldGet(_data, this).fields;
    }
  }, {
    key: "array",
    get: function get() {
      var _classPrivateFieldGet2 = _classPrivateFieldGet(_data, this),
        array = _classPrivateFieldGet2.array;
      return array;
    }
  }, {
    key: "chart",
    get: function get() {
      return _classPrivateFieldGet(_chart, this);
    }
  }, {
    key: "table",
    get: function get() {
      return [this.fields].concat((0, _toConsumableArray2["default"])(this.rows));
    }
  }, {
    key: "origin",
    get: function get() {
      return _classPrivateFieldGet(_data, this).origin;
    }
  }, {
    key: "copiedChart",
    get: function get() {
      if (!_classPrivateFieldGet(_copiedChart, this)) {
        _classPrivateFieldSet(_copiedChart, this, (0, _cloneDeep2["default"])(_classPrivateFieldGet(_chart, this)));
      }
      return _classPrivateFieldGet(_copiedChart, this);
    }
  }, {
    key: "dataTable",
    get: function get() {
      return {
        id: this.id,
        name: this.name,
        chart: _classPrivateFieldGet(_chart, this),
        table: this.table
      };
    }
  }, {
    key: "setArray",
    value: function setArray(_ref3) {
      var chart = _ref3.chart,
        data = _ref3.data,
        fields = _ref3.fields,
        name = _ref3.name;
      _classPrivateFieldSet(_chart, this, chart);
      _classPrivateFieldSet(_name, this, name);
      _classPrivateFieldSet(_source, this, _objectSpread(_objectSpread({}, _classPrivateFieldGet(_source, this)), {}, {
        fields: fields,
        data: data,
        name: name
      }));
      _classPrivateFieldGet(_data, this).from(_classPrivateFieldGet(_source, this));
    }
  }, {
    key: "getValue",
    value: function getValue(index) {
      return _classPrivateFieldGet(_data, this).getValue(index);
    }
  }, {
    key: "isExist",
    value: function isExist(index) {
      var isExist = this.getValue(index);
      return !!(isExist === null || isExist === 0 || isExist);
    }
  }, {
    key: "appendRow",
    value: function appendRow(data) {
      var _this2 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(resolve, reject) {
          var appendOp;
          return _regenerator["default"].wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                try {
                  appendOp = _classPrivateFieldGet(_data, _this2).getOperation({
                    type: 'appendRow',
                    data: data
                  });
                  _classPrivateFieldGet(_data, _this2).exec(appendOp);
                  resolve();
                  _this2.applyChart();
                } catch (e) {
                  reject(e);
                }
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "appendCol",
    value: function appendCol(data) {
      var _this3 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve, reject) {
          var appendOp;
          return _regenerator["default"].wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  appendOp = _classPrivateFieldGet(_data, _this3).getOperation({
                    type: 'appendCol',
                    data: data
                  });
                  _classPrivateFieldGet(_data, _this3).exec(appendOp);
                  resolve();
                  _this3.applyChart();
                } catch (e) {
                  reject(e);
                }
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x3, _x4) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "insertRow",
    value: function insertRow(index, data) {
      var _this4 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(resolve, reject) {
          var insertOp;
          return _regenerator["default"].wrap(function (_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  insertOp = _classPrivateFieldGet(_data, _this4).getOperation({
                    type: 'insertRow',
                    index: index,
                    data: data
                  });
                  _classPrivateFieldGet(_data, _this4).exec(insertOp);
                  resolve();
                  _this4.applyChart();
                } catch (e) {
                  reject(e);
                }
              case 1:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x5, _x6) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "insertCol",
    value: function insertCol(index, data) {
      var _this5 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve, reject) {
          var insertOp;
          return _regenerator["default"].wrap(function (_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                try {
                  insertOp = _classPrivateFieldGet(_data, _this5).getOperation({
                    type: 'insertCol',
                    index: index,
                    data: data
                  });
                  _classPrivateFieldGet(_data, _this5).exec(insertOp);
                  _classPrivateFieldSet(_copiedChart, _this5, _this5.copiedChart.map(function (chart) {
                    if (chart.xIndex >= index) {
                      chart.xIndex++;
                    }
                    if (chart.yIndex >= index) {
                      chart.yIndex++;
                    }
                    for (var i = 0; i < chart.categoryIndexes.length; i++) {
                      if (chart.categoryIndexes[i] >= index) {
                        chart.categoryIndexes[i]++;
                      }
                    }
                    return chart;
                  }));
                  resolve();
                  _this5.applyChart();
                } catch (e) {
                  reject(e);
                }
              case 1:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x7, _x8) {
          return _ref7.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "deleteCol",
    value: function deleteCol(index) {
      var _this6 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(resolve, reject) {
          var deleteOp;
          return _regenerator["default"].wrap(function (_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                try {
                  deleteOp = _classPrivateFieldGet(_data, _this6).getOperation({
                    type: 'deleteCol',
                    index: index
                  });
                  _classPrivateFieldGet(_data, _this6).exec(deleteOp);
                  _classPrivateFieldSet(_copiedChart, _this6, _this6.copiedChart.map(function (chart) {
                    if (chart.xIndex == index) {
                      chart.xIndex = -1;
                      chart.yIndex = -1;
                      chart.categoryIndexes = [];
                    } else if (chart.xIndex > index) {
                      chart.xIndex--;
                    }
                    if (chart.yIndex == index) {
                      chart.yIndex = -1;
                      chart.categoryIndexes = [];
                    } else if (chart.yIndex > index) {
                      chart.yIndex--;
                    }
                    for (var i = 0; i < chart.categoryIndexes.length; i++) {
                      if (chart.categoryIndexes[i] == index) {
                        chart.categoryIndexes.splice(i, 1);
                        i--;
                      } else if (chart.categoryIndexes[i] > index) {
                        chart.categoryIndexes[i]--;
                      }
                    }
                    return chart;
                  }));
                  resolve();
                  _this6.applyChart();
                } catch (e) {
                  reject(e);
                }
              case 1:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x9, _x0) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(index) {
      var _this7 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref9 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(resolve, reject) {
          var deleteOp;
          return _regenerator["default"].wrap(function (_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                try {
                  deleteOp = _classPrivateFieldGet(_data, _this7).getOperation({
                    type: 'deleteRow',
                    index: index
                  });
                  _classPrivateFieldGet(_data, _this7).exec(deleteOp);
                  resolve();
                  _this7.applyChart();
                } catch (e) {
                  reject(e);
                }
              case 1:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x1, _x10) {
          return _ref9.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "replaceValue",
    value: function replaceValue(index, data) {
      var _this8 = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref0 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(resolve, reject) {
          var replaceOp;
          return _regenerator["default"].wrap(function (_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                try {
                  replaceOp = _classPrivateFieldGet(_data, _this8).getOperation({
                    type: 'replace',
                    index: index,
                    data: data
                  });
                  _classPrivateFieldGet(_data, _this8).exec(replaceOp);
                  resolve();
                  _this8.applyChart();
                } catch (e) {
                  reject(e);
                }
              case 1:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return function (_x11, _x12) {
          return _ref0.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        _id: _classPrivateFieldGet(_data, this)._id,
        id: _classPrivateFieldGet(_id, this),
        project: Entry.projectId,
        fields: this.fields,
        name: _classPrivateFieldGet(_name, this),
        object: _classPrivateFieldGet(_object, this),
        data: this.array,
        origin: _classPrivateFieldGet(_data, this).origin,
        chart: _classPrivateFieldGet(_chart, this),
        isCloud: _classPrivateFieldGet(_isCloud, this),
        cloudDate: _classPrivateFieldGet(_cloudDate, this),
        summary: this.summary,
        updated: this.updated
      };
    }
  }, {
    key: "getCoefficient",
    value: function getCoefficient(colX, colY) {
      return corr.apply(void 0, (0, _toConsumableArray2["default"])(getColumns(this.rows, [colY, colX])));
    }
  }, {
    key: "clone",
    value: function clone() {
      return {
        name: _classPrivateFieldGet(_name, this),
        fields: (0, _toConsumableArray2["default"])(this.fields),
        data: (0, _cloneDeep2["default"])(_classPrivateFieldGet(_data, this).origin),
        chart: (0, _toConsumableArray2["default"])(_classPrivateFieldGet(_chart, this))
      };
    }
  }]);
}();
var _default = exports["default"] = DataTableSource;